export default __webpack_public_path__ + "static/media/warning.f3465cfc.svg";